import { markAppBootStep } from 'hybridspace-telemetry/lib/logAppBootStep';
import { logStartGreyError } from 'owa-analytics-start';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';
import { isRunningInMetaOSHub } from 'owa-config/lib/isRunningInMetaOSHub';
import { isBootFeatureEnabled } from 'owa-metatags/lib/isBootFeatureEnabled';
import { tryGetGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import type * as lazyIndex from './bootFunctions';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => {
        return markAppBootStep(
            import(/* webpackChunkName: "PlacesBoot" */ './bootFunctions'),
            'PlacesBootBundle'
        );
    },
    { name: 'PlacesBoot' }
);

export const lazyBootstrap: LazyAction<typeof lazyIndex.bootstrap, typeof lazyModule> =
    new LazyAction(lazyModule, m => m.bootstrap);

// With the boot flight enabled, we should be able to fetch the offline session data pretty quickly, so we'll trigger the boot bundle preloading process here.
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function isRunningInMetaOSHub called at module scope is not allowed. This may cause unwanted side effects.
 *	> Function isBootFeatureEnabled called at module scope is not allowed. This may cause unwanted side effects. */
if (isRunningInMetaOSHub() && isBootFeatureEnabled('msplaces-hosted-localsessiondata-v2')) {
    /* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
     * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
     *	> Function catch called at module scope is not allowed. This may cause unwanted side effects.
     *	> Function importModule called at module scope is not allowed. This may cause unwanted side effects. */
    lazyModule.importModule('PlacesPreloadBootBundle')?.catch(err => {
        logStartGreyError(
            'PlacesPreloadBootBundleError',
            tryGetGlobalSettingsAccountMailboxInfo(),
            err
        );
    });
}
